import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-us-terms',
  templateUrl: './us-terms.component.html',
  styleUrls: ['./us-terms.component.scss']
})
export class UsTermsComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle('ENATIV Terms of Service');
  }
}
